function decodeHtmlEntities(value) {
  if (typeof value !== "string" || value.indexOf("&") === -1) {
    return value;
  }

  const textarea = document.createElement("textarea");
  textarea.innerHTML = value;
  return textarea.value;
}

export function normalizeMoodleCourse(course) {
  if (!course || typeof course !== "object") {
    return course;
  }

  return {
    ...course,
    fullname: decodeHtmlEntities(course.fullname),
    displayname: decodeHtmlEntities(course.displayname),
  };
}

export function normalizeMoodleCourses(courses) {
  if (!Array.isArray(courses)) {
    return courses;
  }

  return courses.map(normalizeMoodleCourse);
}